var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row date-time-select" },
    [
      _c("DatePicker", {
        staticClass: "small-2 medium-2 large-2 columns",
        class: _vm.highlightClass,
        attrs: {
          disabledPicker: _vm.disabled,
          format: _vm.displayDateFormat,
          disabled: _vm.disabledDatesForDatePicker,
          required: _vm.required,
          clearButton: _vm.showClearBtn,
          canPutTotop: _vm.canPutTotop,
          calendarButton: true,
          calendarButtonIcon: "fa fa-calendar",
          value: _vm.formattedDate[0],
          dirtyCheckNode: _vm.dirtyCheckNode,
          dirtyCheck: _vm.dirtyCheck,
        },
        on: {
          selected: function (val) {
            return _vm.updateDate(val, _vm.selectedTime)
          },
          cleared: function ($event) {
            return _vm.updateDate(null, null)
          },
        },
      }),
      _vm._v(" "),
      _c("HKLSelect", {
        staticClass: "small-2 medium-2 large-2 columns",
        class: _vm.highlightClass,
        staticStyle: {
          width: "140px",
          "min-width": "140px",
          "vertical-align": "bottom",
        },
        attrs: {
          disabled: _vm.disabled,
          value: _vm.formattedDate[1] || undefined,
          options: _vm.timeHklOptions,
          showSearch: true,
          required: _vm.required,
          placeholder: "",
        },
        on: {
          change: function (val) {
            return _vm.updateDate(_vm.selectedDate, val)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }